export { HighlightText } from './highlight-text';

